import React, {Component} from 'react';

export class PickupAddressCard extends Component{
    constructor(props) {
        super(props);
    }

    render(){
        return(
            <div id="Pickup-Address-Card" className="col-sm-12 col-md-6 mt-3" data-pickup_details>
                <div className="card border border-dark p-2">
                <div className="display-5 mb-2">Pickup Address</div>                
                <div className="row">                   
                    <div className="col-md-12 col-sm-9">
                        <label className="control-label">Full Street Address</label>                
                        <input required name="pickupAddress.streetAddress" className="form-control"/>
                        <span asp-validation-for="pickupAddress.streetAddress" className="text-danger"></span>
                    </div>  
                    <div className="col-md-6 col-sm-9 mt-sm-2">
                        <label className="control-label">City</label>                
                        <input required name="pickupAddress.City" className="form-control"/>
                        <span asp-validation-for="pickupAddress.City" className="text-danger"></span>
                    </div>
                    <div className="col-md-6 col-sm-8 mt-sm-2">
                        <label className="control-label">State</label>
                        <input required name="pickupAddress.State" className="form-control"/>
                        <span asp-validation-for="pickupAddress.State" className="text-danger"></span>
                    </div>
                    <div className="col-md-6 col-sm-8 mt-sm-2">
                        <label className="control-label">ZIP Code</label>
                        <input required name="pickupAddress.ZIPCode" className="form-control"/>
                        <span asp-validation-for="pickupAddress.ZIPCode" className="text-danger"></span>        
                    </div>
                    <div className="col-md-6 col-sm-8 mt-sm-2">
                        <label className="control-label">Country</label>
                        <input required readOnly aria-disabled="true" name="pickupAddress.Country" className="form-control readOnly" value="US"/>
                        <span asp-validation-for="pickupAddress.Country" className="text-danger"></span>
                    </div>
                    <div className="col-12 mt-1">
                        <em><small>If one of more cars have a different pickup address, specify them when filling out the vehicle information later on in this form</small></em>                
                    </div>
                </div>
            </div>
        </div>
        )

    };

}